import React from 'react'

function Anime() {
  return (
    <div className='anime-list'>
        <ul>
            <li>One Piece (62)</li>
            <li>Death Note (19)</li>
            <li>Naruto (61)</li>
            <li>Chainsaw Man (18)</li>
            <li>One Punch Man (20)</li>
        </ul>
    </div>
  )
}

export default Anime;